import type { ComponentProps, ReactNode } from "react"
import { Field } from "../components/ui/field"
import FieldDescriptionOrError from "./FieldDescriptionOrError"
import { Label } from "@/ui/components/ui/label"
import { Textarea } from "@/ui/components/ui/textarea"
import { cn } from "@/ui/lib/utils"

type Props = ComponentProps<typeof Textarea> & {
  label?: ReactNode
  error?: string | null
  helperText?: string
}

export default function TextareaField({
  label,
  error,
  helperText,
  name,
  required,
  className,
  ...props
}: Props) {
  return (
    <Field className={cn("flex flex-col gap-1.5", className)}>
      <div className="flex flex-col gap-1.5">
        {!!label && (
          <Label
            htmlFor={name}
            className={cn(required && "after:content-['*']")}
          >
            {label}
          </Label>
        )}
        <div className="relative grow">
          <Textarea id={name} name={name} {...props} />
        </div>
      </div>
      <FieldDescriptionOrError description={helperText} error={error} />
    </Field>
  )
}
